import {connect, useDispatch} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {assetProbe} from "../../actions/assetActions";
import QRScanner from "../QRScanner";
import {useField} from "formik";
import SearchableSelect from "./SearchableSelectBox";
import {Form} from "react-bootstrap";
import '../../assets/styles/bottom-sheet.css'
import {locationProbe} from "../../actions/locationActions";
import {ILocation} from "../../models/ILocation";
import {SingleValue} from "react-select";
import {Option} from "../../models/types";
import {IAsset} from "../../models/IAsset";
import {useTranslation} from "react-i18next";

interface Props {
    dispatch: Function;
    label: string;
    name: string;
    target?: string;
    scanOnload?: boolean;
    id?: string;
    entity?: any;
    probedLocation: ILocation;
    probedAsset: IAsset;
    iconShakeInterval?: number;
    required?: boolean;
}

const ScannerField :  React.FC<Props> = ({ ...props}) => {
    const scannerIdRef = useRef<string>(
        props.id || `reader-${props.name || "scanner"}-${Math.random().toString(36).slice(2, 9)}`
    );
    const [ pValue, setPValue ] = useState({label: '', value: ''});
    const { i18n } = useTranslation();
    // @ts-ignore
    const t = (txt: string) => i18n.t(txt);

    const [field, meta, helpers] = useField(props);
    const { setValue } = helpers;
    const [scan, setScan] = useState(false);

    const onResultLocation = (data: string) => {
        const locationValue = data.split('/').pop();

        if(locationValue)
        {
            props.dispatch(locationProbe(locationValue))
        }
    }
    const onResultAsset = (data: string) => {
        let assetValue = data;
        try {
            const urlObj = new URL(data);
            assetValue = urlObj.searchParams.get("asset") || data;
        } catch (err) {
            assetValue = data;
        }

        if (assetValue) {
            props.dispatch(assetProbe(assetValue));
        }
    };

    const target = props.target || 'location';
    const onResult = target === 'asset' ? onResultAsset : onResultLocation;
    const probedEntity = target === 'asset'
        ? (props.probedAsset || props.entity)
        : (props.probedLocation || props.entity);
    const searchController = target === 'asset' ? 'asset' : 'location';

    useEffect(() => {
        if (probedEntity) {
            setPValue({
                value: probedEntity.id,
                label: probedEntity.name,
            });

            setValue({
                value: probedEntity.id,
                label: probedEntity.name,
            });
        }
    }, [props.probedLocation, props.probedAsset, props.entity, target, setValue]);

    const handleSetValue = (value: SingleValue<Option>) => {
        setValue(value);
    }

    return(
        <>
            <Form.Group controlId={props.id || props.name}>
                <Form.Label
                    className={props.required ? "required-label" : undefined}
                    style={{ paddingTop: "10px", paddingBottom: "0px", marginBottom: "0px", textTransform: "capitalize"}}
                >
                    {t(props.label)}
                </Form.Label>
                <div className='d-flex s-wrapper'>
                    <SearchableSelect controller={searchController} wrap={false} value={pValue} onSelect={handleSetValue} {...props}/>
                    <QRScanner
                        compact={true}
                        onResult={onResult}
                        scanOnload={props.scanOnload !== false}
                        id={scannerIdRef.current}
                        iconShakeInterval={props.iconShakeInterval}
                    />
                </div>
                {/* Error message for Formik */}
                {meta.touched && meta.error ? (
                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                ) : null}
            </Form.Group>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    probedLocation: state.location.probed_location,
    probedAsset: state.asset.asset
});

export default connect(mapStateToProps)(ScannerField);
